import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const BackgroundWrapper = styled.div`
  position: absolute;
  overflow: hidden;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  ${media.sm`
    width: 75%;
  `}

  ${media.xxl`
    width: 70%;
  `}
`
